export default {
    users : null,
    jobDraft: {
        
    }
}